
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.092 9.592a5 5 0 10-6.184 0 8.334 8.334 0 00-5.183 6.816.838.838 0 101.667.184 6.667 6.667 0 0113.25 0 .833.833 0 00.833.741h.092a.833.833 0 00.733-.916 8.333 8.333 0 00-5.208-6.825zM9 9a3.333 3.333 0 110-6.667A3.333 3.333 0 019 9z","fill":"#979797"}})])
          )
        }
      }
    